import * as Yup from 'yup';

export default Yup.object().shape({
    // nomeAgencia: Yup.string('Campo deve ser um número!').min(2,'Campo deve ter pelo menos 2 caracteres!').required('Campo obrigatório!'),
    // numeroAgencia: Yup.string('Campo deve ser um número!').min(2,'Campo deve ter pelo menos 2 caracteres!').required('Campo obrigatório!'),
});
